let url = "https://api.airshipbd.com/v1/admin";
// let url = "http://192.168.0.104:3070/v1/admin";
export default url;
